import { COMPANY, CITIES, SERVICE_LINKS } from "../lib/constants";
import { createWhatsAppLink } from "../lib/whatsapp";

export function Footer() {
  return (
    <footer className="home-footer" data-testid="homepage-footer">
      <div className="footer-brand" data-testid="footer-brand">
        <img src="/img/logo-auto-socorro-pedrinho.webp" width="130" height="62" alt="Auto Socorro Pedrinho" loading="lazy" data-testid="footer-logo-image" />
        <p data-testid="footer-description">Guincho, reboque e socorro mecânico 24 horas em Arujá/SP e região.</p>
        <a href={createWhatsAppLink()} data-testid="footer-whatsapp-link">Clique e fale agora pelo WhatsApp</a>
      </div>
      <div data-testid="footer-contact-block"><h3>Contato</h3><p data-testid="footer-phone-text">{COMPANY.phone}</p><p data-testid="footer-address-text">{COMPANY.address}</p><p data-testid="footer-hours-text">Atendimento 24 horas</p></div>
      <div data-testid="footer-cities-block"><h3>Cidades</h3>{CITIES.slice(0, 4).map(([city, href], index) => <a key={city} href={href} data-testid={`footer-city-link-${index}`}>{city}</a>)}</div>
      <div data-testid="footer-services-block"><h3>Serviços</h3>{SERVICE_LINKS.map(([service, href], index) => <a key={service} href={href} data-testid={`footer-service-link-${index}`}>{service}</a>)}</div>
      <small className="copyright" data-testid="footer-copyright">© {new Date().getFullYear()} Auto Socorro Pedrinho. NAP consistente para SEO local.</small>
    </footer>
  );
}